var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IQuote',{attrs:{"label":_vm.blok.label,"quote-size":_vm.blok.quoteTextSize,"title":_vm.blok.title,"quote":_vm.blok.quote,"citation":_vm.blok.citation,"inverted":false,"fontB1":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }